export function isAnchorUrl(url) {
  return url.startsWith('#');
}